// extracted by mini-css-extract-plugin
module.exports = {"link":"_15APC","placeholder":"ZMgqC","playerArea":"_2EtPn"};